import Clock from "@assets/icons/clock-bulk.svg";
import CloseSquare from "@assets/icons/close-square.svg";
import TickSquare from "@assets/icons/tick-square.svg";

type Props = {
  text?: string;
};

export const PaymentCredited = ({ text }: Props) => {
  return (
    <div className="w-full flex flex-col items-center">
      <TickSquare className="w-[72px]" />
      <label className="flex items-center h-[38px] text-[#10B58C]">
        {text || "Платеж зачислен"}
      </label>
    </div>
  );
};

export const PaymentNotCredited = ({ text }: Props) => {
  return (
    <div className="w-full flex flex-col items-center">
      <CloseSquare className="w-[72px]" />
      <label className="flex items-center h-[38px] text-[#F53737]">
        {text || "Платеж не зачислен"}
      </label>
    </div>
  );
};

export const PaymentProcessing = ({ text }: Props) => {
  return (
    <div className="w-full flex flex-col items-center">
      <Clock className="w-[72px] h-[72px]" />
      <label className="flex items-center h-[38px]">
        {text || "Аппеляция на рассмотрении"}
      </label>
    </div>
  );
};
